import { Vue, BitrixVue } from 'ui.vue';
import { userStore } from 'germes.multibasket';
Vue.component('vue-product-quantity-whait-toggle-button', {
    data() {
        return {
            possibility: 0
        };
    },
    computed: {
        localize() {
            return Vue.getFilteredPhrases("VUE_");
        },
        cartProduct(state) {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/findItem'](state.$props.productId) : null;
        },
        cartProductPossibility(state) {
            return parseFloat(state.cartProduct?.CAN_BUY_IN_PERCENT);
        },
        basketStatus(state) {
            return state.$store.getters['basket/basketStatus'];
        },
        catalogProduct(state) {
            return state.$store.getters['catalog/findItem'](state.$props.productId);
        },
        catalogProductPossibility(state) {
            return parseFloat(state.catalogProduct?.CAN_BUY_IN_PERCENT);
        },
        catalogProductWaitFromRetail(state) {
            return state.cartProduct?.PROPS?.WHAIT_FROM_RC?.VALUE == 'Y';
        },
        productProgressPosibility(state) {
            if (state.$props.progressPosibility
                && state.possibility != state.$props.progressPosibility
            ) {
                state.possibility = state.$props.progressPosibility;
            } else if (parseInt(state.catalogProduct?.QUANTITY) != parseInt(state.cartProduct?.QUANTITY)
                && state.catalogProductPossibility >= 0
                && state.possibility != state.catalogProductPossibility
            ) {
                state.possibility = state.catalogProductPossibility;
            } else if (state.cartProductPossibility >= 0
                && state.possibility != state.cartProductPossibility
            ) {
                state.possibility = state.cartProductPossibility;
            }
            return state.possibility;
        },
        catalogProductRetailQuantity(state) {
            let quantity = 0;
            if (state.catalogProduct) {
                if (state.catalogProduct.STORE && state.catalogProduct.STORE.RC)
                    quantity = parseFloat(state.catalogProduct.STORE.RC);
                if (state.catalogProduct.QUANTITY_RC)
                    quantity = parseFloat(state.catalogProduct.QUANTITY_RC);
            }
            return quantity;
        },
        catalogProductRetailCanBuy(state) {
            return (state.catalogProductRetailQuantity > 0 && state.productProgressPosibility > 0 && state.productProgressPosibility < 100);
        },
        title(state) {
            return state.localize.STROE_DELIVERY_RC?.replace('#QUANTITY_RC#', state.catalogProductRetailQuantity);
        }
    },
    methods: {
        toggleWhait: function (event) {
            if (typeof this.cartProduct?.PROPS == 'undefined') this.cartProduct.PROPS = {};
            if (this.cartProduct?.PROPS?.WHAIT_FROM_RC?.VALUE != "Y") {
                return this.$store.dispatch('basket/setProductProperty', {
                    ID: this.cartProduct.ID,
                    PRODUCT_ID: this.cartProduct.PRODUCT_ID,
                    PROPS: {
                        WHAIT_FROM_RC: {
                            NAME: this.localize?.VUE_PROP_WHAIT_FROM_RC || 'WHAIT_FROM_RC',
                            CODE: 'WHAIT_FROM_RC',
                            VALUE: 'Y'
                        }
                    }
                });
            } else {
                return this.$store.dispatch('basket/setProductProperty', {
                    ID: this.cartProduct.ID,
                    PRODUCT_ID: this.cartProduct.PRODUCT_ID,
                    PROPS: {
                        WHAIT_FROM_RC: {
                            CODE: 'WHAIT_FROM_RC',
                            VALUE: false
                        }
                    }
                });
            }
        },
    },
    props: {
        'productId': Number,
        'productAnalog': String
    },
    template: `
            <div
                v-if="cartProduct && catalogProductRetailCanBuy"
                :id="'WAIT_'+productId"
                @click.stop="toggleWhait"
                :title="title"
                data-toggle="tooltip"
                data-placement="bottom"
                class="text-danger pointer"
                >
                <i :class="[{far: !catalogProductWaitFromRetail},{fas: catalogProductWaitFromRetail }, 'fa-clock']"></i>
            </div>`
});
BX.addCustomEvent("OnAfterUserStoreInit", BX.proxy(function () {
    if (typeof userStore !== 'undefined') userStore.commit("catalog/addProductSettingsModule", { name: 'vue-product-quantity-whait-toggle-button' });
}, this));
